import { PageContext } from '../../services/build/types';
import { timestamp } from '../../utils';
import { page, consent, pageContent } from '../tracking-constants';
import { DefaultPageViewEvent } from '../types';

export const defaultPageView = (data: PageContext): DefaultPageViewEvent => ({
  event: 'defaultPageView',
  timestamp: timestamp(),
  page: page(data),
  consent: {
    user: consent(),
  },
  content: pageContent(data),
});
